/**
 * Autogenerated file.
 * For adding or changing icons, see README.MD
 */
import React from 'react';
import { createIcon } from '../../icon/create-icon'; // Outline

const ArrowRightOutline = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M3.75 12h16.5m0 0L13.5 5.25M20.25 12l-6.75 6.75"
})); // Fill


const ArrowRightFill = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "m20.78 12.533-6.75 6.75a.758.758 0 0 1-1.16-.118.761.761 0 0 1-.12-.416v-6h-9a.751.751 0 0 1 0-1.5h9v-6c0-.148.04-.293.12-.416.09-.124.2-.22.34-.278a.776.776 0 0 1 .43-.04c.15.029.29.098.39.2l6.75 6.75c.15.142.22.334.22.534s-.07.392-.22.534z"
})); // DuoTone


const ArrowRightDuotone = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M3.75 12h16.5m0 0L13.5 5.25M20.25 12l-6.75 6.75"
}));
/**
  Icon ArrowRightIcon in arrows group
*/


export const ArrowRightIcon = createIcon('ArrowRightIcon', 'arrow-right', 'arrows', ArrowRightOutline, ArrowRightFill, ArrowRightDuotone, "0 0 24 24");